export const getWeekDays = (t) => {
    return [
        t("base.weekDays.monday.short"),
        t("base.weekDays.tuesday.short"),
        t("base.weekDays.wednesday.short"),
        t("base.weekDays.thursday.short"),
        t("base.weekDays.friday.short"),
        t("base.weekDays.saturday.short"),
        t("base.weekDays.sunday.short")
    ];
};
export const typeOfDays = ['previous', 'current', 'next'];
export const getMonths = (t) => {
    return [
        t("base.months.january.nom"),
        t("base.months.february.nom"),
        t("base.months.march.nom"),
        t("base.months.april.nom"),
        t("base.months.may.nom"),
        t("base.months.june.nom"),
        t("base.months.july.nom"),
        t("base.months.august.nom"),
        t("base.months.september.nom"),
        t("base.months.october.nom"),
        t("base.months.november.nom"),
        t("base.months.december.nom")
    ];
};
